import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="3.333" y="4.167" width="13.333" height="4.167" rx="1" stroke="currentColor" strokeLinejoin="round" /><rect x="3.333" y="11.667" width="13.333" height="4.167" rx="1" stroke="currentColor" strokeLinejoin="round" /></svg>;